import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = hash.get("session_id");
    const params = new URLSearchParams(window.location.search);
    const role = params.get("role") || "traveler";
    const next = params.get("next");
    if (!sessionId) {
      setError(true);
      return;
    }
    (async () => {
      try {
        const u = await googleLogin(sessionId, role);
        toast.success(`Welcome, ${u.name}!`);
        const dest = next || (u.role === "host" ? "/host" : u.role === "service_provider" ? "/provider" : "/");
        window.history.replaceState(null, "", window.location.pathname);
        navigate(dest, { replace: true });
      } catch {
        setError(true);
      }
    })();
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 text-[#717171]" data-testid="auth-callback">
      {error ? (
        <>
          <p className="text-[#222] font-semibold">Sign-in failed.</p>
          <button onClick={() => navigate("/login")} className="text-[#FF385C] font-semibold hover:underline">Back to login</button>
        </>
      ) : (
        <>
          <Loader2 className="w-8 h-8 animate-spin text-[#FF385C]" />
          <p>Signing you in...</p>
        </>
      )}
    </div>
  );
}
